import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-left-doodle.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-right-doodle.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/features2.svg';

var ProductsCarousel = function ProductsCarousel() {
  return import('~/components/organisms/Global/ProductsCarousel.vue');
};

export default {
  components: {
    ProductsCarousel: ProductsCarousel
  },
  props: {
    image: {
      type: Object,
      required: true
    },
    products: {
      type: Array,
      required: true
    },
    reference: {
      type: String,
      default: null
    }
  }
};